import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Endpoints } from 'src/app/shared/config/endpoints';

import { GeneralService } from '../general.service';
import { EXTRACTOBJVALUETOARR } from 'src/app/helpers/helperResources';

@Injectable({
  providedIn: 'root',
})
export class DealPipelineWorkflowService {
  private signupUrl = this.config.signUpEndpoint;
  constructor(
    private http: HttpClient,
    private config: Endpoints,
    private gs: GeneralService
  ) {}

  // Deal PipeLine  Api Config
  private get dealPipelineWorkflowAPI() {
    const url =
      this.config.settingsUrl + this.config.dealPipeLineWorkflow.baseurl;
    return url;
  }

  /**
   * Deal Pipeline
   */

  getDealsPipelineWorkflow(): Observable<any> {
    return this.http
      .get<any>(
        this.dealPipelineWorkflowAPI +
          '/' +
          this.gs.orgID +
          this.config.dealPipeLineWorkflow.getDealsPipelineWorkflows
      )
  }

  /**
   *
   * @param DealWorkFlow
   */
  // Create =>  POST: add a new user to the server
  createDealWorkflow(dealWorkFlow): Observable<any> {
    return this.http
      .post<any>(
        this.dealPipelineWorkflowAPI +
          this.config.dealPipeLineWorkflow.newDealsPipelineWorkflow,
        dealWorkFlow
      )
  }

  // edit =>  POST: add a new user to the server
  editDealWorkflow(dealWorkFlow): Observable<any> {
    return this.http
      .post<any>(
        this.dealPipelineWorkflowAPI +
          this.config.dealPipeLineWorkflow.editDealsPipelineWorkflow,
        dealWorkFlow
      )
  }

  getDealsPipelineWorkflowById(workflowId: any): Observable<any> {
    return this.http
      .get<any>(
        this.dealPipelineWorkflowAPI +
          `/${workflowId}` +
          this.config.dealPipeLineWorkflow.getDealsPipelineWorkflowById
      )
  }

  deleteDealsPipelineWorkflow(workflowId: any) {
    const url =
      this.dealPipelineWorkflowAPI +
      `/${workflowId}` +
      this.config.dealPipeLineWorkflow.deleteDealsPipelineWorkflowById;
    return this.http.delete<any>(url)
  }
  updateDealWorkflowStatus(id) {
    return this.http.get(this.dealPipelineWorkflowAPI+`/${id}/changeDealsPipelineWorkflowStatus`);
  }

  /**
   *
   * @param DealStage
   */

  // Create =>  POST: add a new user to the server
  createDealStage(dealStage): Observable<any> {
    return this.http
      .post<any>(
        this.dealPipelineWorkflowAPI +
          this.config.dealPipeLineWorkflow.newDealsPipelineStage,
        dealStage
      )
  }

  // edit =>  POST: add a new user to the server
  editDealStage(dealStage): Observable<any> {
    return this.http
      .post<any>(
        this.dealPipelineWorkflowAPI +
          this.config.dealPipeLineWorkflow.editDealsPipelineStages,
        dealStage
      );
  }

  getDealsPipelineWStageById(stageId: any): Observable<any> {
    return this.http
      .get<any>(
        this.dealPipelineWorkflowAPI +
          `/${stageId}` +
          this.config.dealPipeLineWorkflow.getDealsPipelineStageById
      )
  }

  getDealsPipelineStageByDealId(dealsPipelineID: any): Observable<any> {
    return this.http
      .get<any>(
        this.dealPipelineWorkflowAPI +
          `/${dealsPipelineID}` +
          this.config.dealPipeLineWorkflow.getDealsPipelineStagesByDealId
      )
  }

  deleteDealsPipelineStage(stageId: any) {
    const url =
      this.dealPipelineWorkflowAPI +
      `/${stageId}` +
      this.config.dealPipeLineWorkflow.deleteDealsPipelineStageById;
    return this.http.delete<any>(url);
  }
  fetchDealReasons() {
    return this.http.get(this.dealPipelineWorkflowAPI+`/${this.gs.orgID}/getDealsLostComments`);
  }

  createDealReason(name) {
    const body = {
      orgID: this.gs.orgID,
      value: name
    }
    return this.http.post(this.dealPipelineWorkflowAPI+ '/newDealsLostComment', body);
  }
  deleteDealReason(id) {
    return this.http.delete(this.dealPipelineWorkflowAPI+`/${id}/deleteDealsLostComment`);
  }
  attactTeamToDealWorkflow(payload: {userID: any[], workflowID: number}) {
    const body = {...payload, orgID: this.gs.org.id}
    return this.http.post(`${this.dealPipelineWorkflowAPI}/assignDealsPipelineWorkflow`, body)
  }
  removeAttatedUsersFromWorkflow(payload: {userID: any[], workflowID: number}) {
    const body = {
      orgID: this.gs.org.id,
      userID: payload.userID,
      workflowID: payload.workflowID
    }
    return this.http.post(`${this.dealPipelineWorkflowAPI}/removeUserFromDealsPipelineWorkflow`, body)
  }
  getWorkflowUsers(workflowID) {
    return this.http.get(this.dealPipelineWorkflowAPI+`/${workflowID}/getDealsPipelineWorkflowUsers`)
    .pipe(
      map((res: any) => {
        let arr = EXTRACTOBJVALUETOARR(res, "userID");
        arr.length > 0 ? arr : (arr = ["0"]);
        return this.fetchUserDetailsForSalesOrderWorkflow(arr);
      })
    );
  }

  fetchUserDetailsForSalesOrderWorkflow(userIds: any[number]) {
    return this.http.get(`${this.signupUrl}/getAllUserDetails/${userIds}`);
  }

  createOrEditDealSource(type, paylaod) {
    const body = {
      id: 0,
      ...paylaod,
      orgID: this.gs.orgID
    }
    return this.http.post(`${this.dealPipelineWorkflowAPI}/${type}`, body)
  }
  fetchDealSource() {
    return this.http.get(`${this.dealPipelineWorkflowAPI}/dealsSources/${this.gs.orgID}`)
  }
  delteDealSource(id) {
    return this.http.delete(`${this.dealPipelineWorkflowAPI}//deleteDealsSource/${id}`);
  }

  updateStageOrder(stages: any[]) {
    const body = {
      stages: stages.map((stage, index) => ({
        id: stage.id,
        number: index + 1
      })),
      orgID: this.gs.orgID
    };
    return this.http.put(`${this.dealPipelineWorkflowAPI}/updateStageOrder`, body);
  }






}
